import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss']
})
export class DropdownFilterComponent implements OnInit {

  @Input() displayDialog : boolean = false;
  @Input() dialogTitle : string = '';
  @Input() dialogtype: String = '';
  @Input() dialogList : any[] = new Array();
  @Input() dialogSelect : any = null;
  @Input() dialogPlaceholder : string = '';

  dialogIsSelected : boolean = false;

  @Output() filterReset = new EventEmitter<String>();
  @Output() filterApplied = new EventEmitter< {data: String ,type: String}>()
  constructor() { }

  ngOnInit(): void {
  }



  @ViewChild('dropdown') dropdown: ElementRef;

//   expandDropdown() {
//     setTimeout(() => {
//         const panel = document.querySelector('.p-dropdown-panel') as HTMLElement;
//         if (panel) {
//             panel.style.maxHeight = '400px'; 
//             panel.style.overflowY = 'auto';
//         }
//     }, 0);
// }

// onDropdownChange() {
//     this.dialogIsSelected = !!this.dialogSelect;
//   }



  resetFilter(){
    this.dialogSelect = null;
    this.dialogIsSelected = false;
    this.filterReset.emit(this.dialogtype);

  }

  applyFilter(){
    this.filterApplied.emit({data : this.dialogSelect ,type: this.dialogtype});
    this.dialogSelect= null;
  }

}
